// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./$.object-sap')('getOwnPropertyNames', function(){
  return require('./$.get-names').get;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es6.object.get-own-property-names.js
 ** module id = 323
 ** module chunks = 1
 **/